<template>
  <el-select
    :value="value"
    :multiple="multiple"
    :multiple-limit="limit"
    @change="handlerChange"
    clearable
    filterable
    :disabled="readonly"
    style="width: 100%"
    placeholder="请选择"
  >
    <el-option
      v-for="item in list"
      :key="item.code"
      :label="item.name"
      :value="item[need]"
    >
      {{ item.name }}
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: {},
    multiple: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 0,
    },
    need: {
      type: String,
      default: "code",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    url: {},
    code: {},
    name: {},
  },
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.$get(this.url).then((r) => {
      this.list = r.Result.map((m) => {
        return {
          code: m[this.code],
          name: m[this.name],
        };
      });
    });
  },
  methods: {
    handlerChange(v) {
      const selectedOption = this.list.find((option) => option.code === v);
      if (selectedOption) {
        const selectedLabel = selectedOption.name; // 获取选中项的名称
        this.$emit("option-selected", v, selectedLabel); // 触发自定义事件，并传递 value 和 name
        this.$emit("input", v);
      }
    },
  },
};
</script>

<style>
</style>